/**
 * @generated SignedSource<<d06618e9eea33e8f1f3c59feba74d5f8>>
 * @relayHash 3f7b9f22dab8cee2c8351c80e7efb1a7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/550.0.0-2026-03-10T14:52:10.721Z/NftPdpRespLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpRespLayoutRefetchQuery$variables = {
  creatorItemCount?: number | null;
  fetchClientDetails: boolean;
  fetchSplitName: boolean;
  fetchUser: boolean;
  isDraft?: boolean | null;
  nftId: string;
  userId: string;
};
export type NftPdpRespLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpRespLayout_viewer">;
  };
};
export type NftPdpRespLayoutRefetchQuery = {
  response: NftPdpRespLayoutRefetchQuery$data;
  variables: NftPdpRespLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "creatorItemCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchClientDetails"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchSplitName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isDraft"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nftId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Photo",
  "kind": "LinkedField",
  "name": "avatarImage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDibsAddress",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "allowWalletConnect"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ether",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAddressZero",
    "storageKey": null
  },
  (v8/*: any*/),
  (v18/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/),
  (v1/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "from",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  (v8/*: any*/),
  (v18/*: any*/),
  (v9/*: any*/),
  (v7/*: any*/),
  (v1/*: any*/)
],
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v22/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "auction",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "to",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v28 = [
  (v2/*: any*/),
  (v1/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "operator",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v31 = {
  "items": [
    {
      "kind": "Variable",
      "name": "nftIds.0",
      "variableName": "nftId"
    }
  ],
  "kind": "ListValue",
  "name": "nftIds"
},
v32 = [
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  },
  (v31/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auctionId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaCopy",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaHref",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v42 = [
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/)
],
v43 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "excludeItemIds.0",
        "variableName": "nftId"
      }
    ],
    "kind": "ListValue",
    "name": "excludeItemIds"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creatorItemCount"
  }
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webUrl",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "posterFrameUrl",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edition",
  "storageKey": null
},
v49 = [
  (v2/*: any*/),
  (v18/*: any*/),
  (v7/*: any*/),
  (v1/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherRates",
  "kind": "LinkedField",
  "name": "etherRates",
  "plural": true,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "NftItemLikes",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likeCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSupply",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isERC1155",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenUri",
  "storageKey": null
},
v58 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v59 = [
  (v58/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v61 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v59/*: any*/),
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "balanceForUser",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v1/*: any*/),
        (v60/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v62 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v63 = [
  (v35/*: any*/),
  (v34/*: any*/),
  (v36/*: any*/),
  (v1/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "caption",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wei",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v4/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocation",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
},
v69 = [
  (v2/*: any*/),
  (v7/*: any*/),
  (v66/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftSplit",
    "kind": "LinkedField",
    "name": "split",
    "plural": false,
    "selections": [
      {
        "condition": "fetchSplitName",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v59/*: any*/),
            "concreteType": "NftSplitBookmark",
            "kind": "LinkedField",
            "name": "bookmark",
            "plural": false,
            "selections": [
              (v44/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "distributorFee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EthereumAddressType",
        "kind": "LinkedField",
        "name": "controllerAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v7/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NftSplitAllocation",
        "kind": "LinkedField",
        "name": "allocations",
        "plural": true,
        "selections": [
          (v67/*: any*/),
          (v68/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/),
              (v66/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftPdpRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftPdpRespLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftPdpRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "nftId",
                "variableName": "nftId"
              }
            ],
            "concreteType": "NftItemBalance",
            "kind": "LinkedField",
            "name": "nftBalancesByItem",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ownerAddress",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v1/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v1/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chainId",
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": (v11/*: any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectEnabled",
            "args": (v11/*: any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "nftId"
              }
            ],
            "concreteType": "NftItemHistory",
            "kind": "LinkedField",
            "name": "nftItemHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "NftItemHistoryEventsConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemHistoryEventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          (v1/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isNftItemHistoryEvent"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "transactionHash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryTransferEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "auctionCreator",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCreatedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "bidAmount",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "bidder",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionBidEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPaused",
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionPausedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherAmount",
                                "kind": "LinkedField",
                                "name": "winningBid",
                                "plural": false,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "winningBidder",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionEndedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "canceledBy",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "NftItemHistoryAuctionCanceledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "valueArg",
                                "storageKey": null
                              },
                              (v20/*: any*/),
                              (v27/*: any*/),
                              (v29/*: any*/)
                            ],
                            "type": "NftItemHistoryTransferSingleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ids",
                                "storageKey": null
                              },
                              (v20/*: any*/),
                              (v27/*: any*/),
                              (v29/*: any*/)
                            ],
                            "type": "NftItemHistoryTransferBatchEvent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "events(first:6)"
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NftPdpHistory_events",
                "kind": "LinkedHandle",
                "name": "events"
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v32/*: any*/),
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v1/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftCmsExhibitionPage",
                "kind": "LinkedField",
                "name": "exhibitions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftCmsExhibitionHeroBannerType",
                    "kind": "LinkedField",
                    "name": "heroBanner",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "bannerConfig",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "eyeBrow",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageSize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "captionPosition",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backgroundColor",
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              (v38/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "captionAlignment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "header",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dek",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "curator",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaStyle",
                                "storageKey": null
                              }
                            ],
                            "type": "NftCmsExhibitionHtmlBannerType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "burnIn",
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              (v38/*: any*/)
                            ],
                            "type": "NftCmsExhibitionStaticBannerType",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "format",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftCmsExhibitionImageType",
                        "kind": "LinkedField",
                        "name": "desktopImage",
                        "plural": false,
                        "selections": (v42/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftCmsExhibitionImageType",
                        "kind": "LinkedField",
                        "name": "mobileImage",
                        "plural": false,
                        "selections": (v42/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v1/*: any*/),
                      (v4/*: any*/),
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bio",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instagramLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitterLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "facebookLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wikipediaLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discordLink",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v43/*: any*/),
                    "concreteType": "EthereumAddressCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "createdItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressCreatedItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "metadata",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v44/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NftDigitalArtMetadataMedia",
                                        "kind": "LinkedField",
                                        "name": "media",
                                        "plural": false,
                                        "selections": [
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v47/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "videoThumb",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v48/*: any*/)
                                    ],
                                    "type": "NftDigitalArtMetadata",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EtherAmount",
                                    "kind": "LinkedField",
                                    "name": "currentBid",
                                    "plural": false,
                                    "selections": (v17/*: any*/),
                                    "storageKey": null
                                  },
                                  (v25/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "winnerAddress",
                                    "plural": false,
                                    "selections": (v49/*: any*/),
                                    "storageKey": null
                                  },
                                  (v50/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NftItem",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v51/*: any*/),
                                      (v1/*: any*/),
                                      (v52/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v23/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "creatorAddress",
                                    "plural": false,
                                    "selections": (v28/*: any*/),
                                    "storageKey": null
                                  },
                                  (v53/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "wasBurned",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "linkData",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLinkable",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "importErrorReason",
                                "storageKey": null
                              },
                              (v1/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "creatorAddress",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v18/*: any*/),
                                  (v1/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              (v56/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ownerAddress",
                                "plural": false,
                                "selections": (v49/*: any*/),
                                "storageKey": null
                              },
                              (v26/*: any*/),
                              (v57/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftTokenContract",
                                "kind": "LinkedField",
                                "name": "contract",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "addressWithFields",
                                    "plural": false,
                                    "selections": (v28/*: any*/),
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v61/*: any*/),
                              {
                                "alias": "recentAuction",
                                "args": (v62/*: any*/),
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": "mostRecentAuction(excludeCanceled:true)"
                              },
                              (v52/*: any*/),
                              {
                                "alias": "auction",
                                "args": (v62/*: any*/),
                                "concreteType": "NftAuction",
                                "kind": "LinkedField",
                                "name": "mostRecentAuction",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": "mostRecentAuction(excludeCanceled:true)"
                              },
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v43/*: any*/),
                    "filters": [
                      "excludeItemIds"
                    ],
                    "handle": "connection",
                    "key": "NftCmsCreator_createdItems",
                    "kind": "LinkedHandle",
                    "name": "createdItems"
                  },
                  (v1/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v56/*: any*/),
              (v26/*: any*/),
              (v57/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "tokenContractImport",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "collectionName",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "medium",
                        "storageKey": null
                      },
                      (v48/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dimensions",
                            "storageKey": null
                          },
                          (v46/*: any*/),
                          (v45/*: any*/),
                          (v47/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aspectRatio",
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v55/*: any*/),
              (v52/*: any*/),
              (v1/*: any*/),
              (v54/*: any*/),
              (v51/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItemCmsLoader",
                "kind": "LinkedField",
                "name": "additionalInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "copy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoEmbed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "videoEmbedCaption",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemCmsImage",
                    "kind": "LinkedField",
                    "name": "imageList",
                    "plural": true,
                    "selections": (v42/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageListCaption",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftExhibitionNote",
                "kind": "LinkedField",
                "name": "exhibitionNotes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "contentList",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v64/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftExhibitionNoteImageListImage",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v39/*: any*/),
                              (v41/*: any*/),
                              (v40/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "NftExhibitionNoteImageListContent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                          }
                        ],
                        "type": "NftExhibitionNoteRichTextContent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "embedCode",
                            "storageKey": null
                          },
                          (v64/*: any*/)
                        ],
                        "type": "NftExhibitionNoteVideoEmbedContent",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "showExhibitionNotes",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftExhibitionNotes"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftExhibitionNotes\")"
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v31/*: any*/),
                  (v58/*: any*/)
                ],
                "concreteType": "NftItemUserLike",
                "kind": "LinkedField",
                "name": "isNftItemsLikedByUser",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nftId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLiked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v59/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "socialNetworkName",
                        "value": "ETHEREUM"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "socialNetworkByName",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumSocialConnectionUserPreferencesType",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zipCode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EthereumSocialConnection",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
                  },
                  (v1/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "ethereumWalletAddress",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchClientDetails",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v32/*: any*/),
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "nftItems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftAuction",
                    "kind": "LinkedField",
                    "name": "mostRecentAuction",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EtherAmount",
                        "kind": "LinkedField",
                        "name": "currentBid",
                        "plural": false,
                        "selections": [
                          (v65/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "winnerAddress",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "fundsRecipient",
                        "plural": false,
                        "selections": (v69/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EtherAmount",
                        "kind": "LinkedField",
                        "name": "reservePrice",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v65/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v50/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "addressWithFields",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v28/*: any*/),
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentAddresses",
                    "kind": "LinkedField",
                    "name": "paymentAddresses",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentAddress",
                        "kind": "LinkedField",
                        "name": "addresses",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "address",
                            "plural": false,
                            "selections": (v69/*: any*/),
                            "storageKey": null
                          },
                          (v67/*: any*/),
                          (v68/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v60/*: any*/),
                  {
                    "alias": "lastLiveAuction",
                    "args": (v62/*: any*/),
                    "concreteType": "NftAuction",
                    "kind": "LinkedField",
                    "name": "mostRecentAuction",
                    "plural": false,
                    "selections": [
                      (v53/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": "mostRecentAuction(excludeCanceled:true)"
                  },
                  (v48/*: any*/),
                  (v61/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/550.0.0-2026-03-10T14:52:10.721Z/NftPdpRespLayoutRefetchQuery",
    "metadata": {},
    "name": "NftPdpRespLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7cc50f9286f10f8f68aa4cd4c7f25cae";

export default node;
